export const TABS = [
  { id: "details", label: "Details" },
  { id: "competitors", label: "Competition" },
];

export const DEFAULT_SERVICE_TERRITORY = "ONCOR";
